module.exports = __webpack_public_path__ + "assets/img/13_332_big.8b4b05ba.jpg";